/**
 * countdown.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input } from "@angular/core";
import * as moment from "moment";

@Component({
    selector: "countdown",
    template: `
<span class="countdown">
    {{formatted}}
</span>
`,
})
export class CountdownComponent
{
    private timer : number;

    private target : moment.Moment = moment();

    public formatted : string = "";

    @Input()
    public set seconds (count : number)
    {
        clearTimeout(this.timer);
        this.target = moment().add(count, "seconds");
        this.calculate();
    }

    @Input()
    public resolution : number = 1000;

    private calculate () : void
    {
        const length : moment.Duration =
            moment.duration(this.target.diff(moment()));
        if (length.asMilliseconds() < 0)
        {
            this.formatted = "0:00";
            return;
        }
        const mm : string = Math.floor(length.asMinutes()).toString(10);
        const ss : string = (1000 + length.seconds()).toString(10).substring(2);
        this.formatted = `${mm}:${ss}`;
        setTimeout(() => this.calculate(), this.resolution);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/controls/countdown.component.ts